import { http } from 'utils'

import { Report19CreateFormTypes, Report19APISchemas} from "schemas/report-19-schemas"

export const  postReport19Service = async(payload: Report19CreateFormTypes) => {

    const url = `/merchant/gift-cards-sales-summaries`
    const response = await http.post(url, payload)
    const result = Report19APISchemas.safeParse(response.data)
    if (!result.success) 
      throw result.error
    return result.data
}
